import React, { Component } from 'react';

export default class Footer extends React.Component {
  render() {
    return(
        <div className="footer">
            <div className="description">Разработка и тех поддержка: Управление Информатизации</div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Footer.js